<template>
  <div class="address-form">
    <div style="height: 10px"></div>
    <van-cell-group>
      <van-field
        input-align="right"
        v-model="formData.taitou"
        label="发票抬头"
        :error="formValidate && !formData.taitou"
        placeholder="请输入发票抬头"
      />
      <van-field
        input-align="right"
        v-model="formData.shuihao"
        label="税号"
        :error="formValidate && !formData.shuihao"
        type="number"
        placeholder="请输入税号"
      /> 
      <van-field
        input-align="right"
        v-model="formData.account"
        label="开户行及账号" 
        :error="formValidate && !formData.account"
        placeholder="请输入开户行及账号"
      />
      <van-field
        input-align="right"
        v-model="formData.address"
        label="购买方地址" 
        :error="formValidate && !formData.address"
        placeholder="请输入购买方地址"
      /> 
      <van-field
        input-align="right"
        v-model="formData.phone"
        label="购买方电话"
        :error="formValidate && !formData.phone"
        placeholder="请输入购买方电话"
      />
      <!-- <van-cell title="是否设为默认">
        <van-switch
          size="24px"
          active-color="#FCAB15"
          v-model="formData.is_default"
        />
      </van-cell> -->
    </van-cell-group>

    <div style="padding: 20px; text-align: center">
      <van-button round size="large" @click.stop="formSave" class="save"
        >保存</van-button
      >
    </div>
    <div
      @click="onDelete"
      style="padding-top: 10px; color: #666; text-align: center"
    >
      删除
    </div>
    <div
      v-show="area_show"
      style="position: fixed; bottom: 0; z-index: 1000; width: 100%"
    >
      <van-popup
        style="top: 50%"
        position="bottom"
        :close-on-click-overlay="false"
        v-model="show"
      >
        <van-area
          :area-list="areaList"
          :value="formData.area_key"
          @confirm="areaConfirm"
          @cancel="areaCancel"
        />
      </van-popup>
    </div>
  </div>
</template>
<style scoped>
.address-form {
  background: #f8f8f8;
  height: 843px;
}
.van-cell:not(:last-child)::after {
  right: 16px;
}
.save {
  width: 155px;
  height: 46px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
</style>
<script>
import Vue from "vue";
import { Popup, CellGroup, Cell, Switch, Area, Dialog, Toast } from "vant";
import areaList from "@/utils/area";

export default {
  name: "AddressList",

  data() {
    return {
      show: true,
      formData: {
        id: "",
        name: "",
        phone: "",
        area_names_string: "",
        area_key: "",
        address: "",
        province: "",
        city: "",
        county: "",
        account:'',
        is_default: true,
      },
      selectAddress: {},
      areaList: areaList,
      list: [],
      area_show: false,
      formValidate: false,

      switchCheck: false,
    };
  },
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Area.name]: Area,
    Dialog,
    Toast,
  },
  mounted: function () {
    document.title = "编辑发票";
    this.getAddressDetail();
  },
  methods: {
    onSelect(address) {
      let that = this;
      that.selectAddress = address;
      that.onChange();
    },
    getAddressDetail() {
      let that = this;
      let id = this.$route.query.id;
      this.$api.get("/api/user/invoiceDetail", { id: id }, (res) => {
        that.formData = res.data;
        if (res.data.is_default == 1) {
          that.switchCheck = true;
        }
      });
    },

    onChange() {
      this.$router.go(-1);
      // this.$router.replace('addresslist');
    },
    areaConfirm(data) {
      let that = this;
      console.log(data);
      that.formData.province = data[0].name;
      that.formData.city = data[1].name;
      that.formData.county = data[2].name;
      that.formData.area_key = data[2].code;
      that.formData.area_names_string =
        data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.area_show = false;
    },
    areaCancel() {
      this.area_show = false;
    },

    formSave: function () {
      let that = this;
      that.formValidate = true;
      that.formData.is_default = that.switchCheck == true ? 1 : 2;

      console.log("that.formData", that.formData);

      for (let field in that.formData) {
        if (!that.formData[field] && (field == "taitou" || field == "shuihao"  || field =='phone' || field =='account' || field =='address')) {
          return;
        }
      } 
      /*for(let field in that.formData){
                  if (!that.formData[field] && field !='is_default'){
                    return ;
                  }
                };*/

      this.$api.get(
        "/api/user/invoiceEdit",
        that.formData,
        (res) => {
          that.onChange();
        },
        (res) => {
          Toast(res.msg);
        }
      );
    },

    onDelete() {
      Dialog.confirm({
        title: "提示",
        message: "确定要删除吗？",
      })
        .then(() => {
          // on confirm
          let that = this;
          this.$api.get(
            "/api/user/invoiceDelete",
            { id: that.formData.id },
            (res) => {
              that.onChange();
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// InvoiceEdit.vue?3a38f86e